import { Coleccion } from "./../../services/coleccion.service";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { IonInput } from "@ionic/angular";
import { Console } from "console";
import { AuthService } from "src/app/services/auth.service";
import { AutorService } from "src/app/services/autor.service";
import { ColeccionService } from "src/app/services/coleccion.service";
import { CursosService } from "src/app/services/cursos.service";

@Component({
  selector: "app-libreria-filtro",
  templateUrl: "./libreria-filtro.component.html",
  styleUrls: ["./libreria-filtro.component.scss"],
})
export class LibreriaFiltroComponent implements OnInit {
  @ViewChildren("filtros") filtros: IonInput[];
  @Output() filtroAplicado = new EventEmitter<any>();
  @Input() filtrosData: any;
  @Input() minprice: any;
  @Input() maxprice: any;
  public searchControl = new FormControl("");
  nivelesAcademicos: any = [];
  private displayUserData: any;
  edades: any = {
    lower: 0,
    upper: 0,
  };
  minedad: number = 1;
  maxedad: number = 100;

  coleccion: any = [];
  coleccionItems: any = [];

  autor: any = [];
  autorItems: any = [];

  precios: any = {
    lower: 0,
    upper: 0,
  };
  rangemin: any = null;
  rangemax: any = null;

  constructor(
    private authService: AuthService,
    private cursosService: CursosService,
    private coleccionService: ColeccionService,
    private autorservice: AutorService
  ) {}

  ngOnInit() {
    this.searchControl.setValue(this.filtrosData?.search || "");
    this.authService.userData$.subscribe((res: any) => {
      if (!this.displayUserData) {
        this.displayUserData = res;
        this.loadColecciones();
        this.loadAutores();
      }
    });
  }

  ngOnChanges() {
    this.reconstruirFiltros();
  }

  reconstruirFiltros() {
    console.log(this.filtrosData);
    this.edades = this.filtrosData?.edades;
    this.precios = this.filtrosData?.precios;
    this.coleccionItems = [...(this.filtrosData?.coleccion || [])];
    this.autorItems = [...(this.filtrosData?.autores || [])];
  }

  setEdad() {
    if (this.edades.lower > this.edades.upper) {
      this.edades.lower = this.edades.upper;
    }
  }

  loadColecciones() {
    let auth_key = 0;
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      auth_key = this.displayUserData?.auth_key;
      if (auth_key)
        this.coleccionService.getAll(auth_key).subscribe((response) => {
          let body = response;
          if (body.auth_key) {
            if (body.data[0] != undefined) {
              this.coleccion = body.data;
            }
          }
        });
    });
  }
  coleccionChkbx(event: any, id: number) {
    if (event.detail.checked) {
      if (!this.coleccionItems.includes(id)) {
        this.coleccionItems.push(id);
      }
    } else {
      this.coleccionItems = this.coleccionItems.filter((item) => item !== id);
    }
  }

  loadAutores() {
    let auth_key = 0;
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      auth_key = this.displayUserData?.auth_key;
      if (auth_key)
        this.autorservice.getAll(auth_key).subscribe((response) => {
          let body = response;
          if (body.auth_key) {
            if (body.data[0] != undefined) {
              this.autor = body.data;
            }
          }
        });
    });
  }

  autorChkbx(event: any, id: number) {
    if (event.detail.checked) {
      if (!this.autorItems.includes(id)) {
        this.autorItems.push(id);
      }
    } else {
      this.autorItems = this.autorItems.filter((item) => item !== id);
    }
  }

  setPrice() {
    this.rangemax = this.precios.upper;
    this.rangemin = this.precios.lower;
  }

  minPrice(): void {
    if (this.rangemin >= this.minprice && this.rangemin <= this.maxprice) {
      if (!this.rangemax) {
        this.rangemax = this.maxprice;
      }
      this.precios = { lower: this.rangemin, upper: this.rangemax };
    }
  }
  maxPrice(): void {
    if (this.rangemax <= this.maxprice && this.rangemax >= this.minprice) {
      if (!this.rangemin) {
        this.rangemin = this.minprice;
      }
      this.precios = { lower: this.rangemin, upper: this.rangemax };
    }
  }

  onSearchInput() {
    this.filtro(false);
  }

  resetFiltros() {
    this.edades = {
      lower: 0,
      upper: 0,
    };
    this.precios = {
      lower: 0,
      upper: 0,
    };
    this.coleccionItems = [];
    this.autorItems = [];
    this.rangemax = null;
    this.rangemin = null;
    this.filtros.forEach((element: any) => {
      element.checked = false;
    });
    this.searchControl.setValue("");
    this.filtro();
  }

  filtro(type = true) {
    this.filtroAplicado.emit({
      search: this.searchControl.value,
      edades: this.edades,
      coleccion: this.coleccionItems,
      autores: this.autorItems,
      precios: this.precios,
      type: type,
    });
  }
}
